'use client'

import NewsCard from "../Global/NewsCard";
import Link from "next/link";
import { useEffect, useState } from "react";

/**
 * Retourne un composant affichant les 3-4 derniers articles publiés
 * @param {object} parametter - Paramètre du composant.
 * @param {"fr"|"en"|"nl"} parametter.lang - Langue du site web.
 * @param {object} parametter.locale - Dictionnaire de la page d'acceuil du site web (local.homepage)
 * @param {object} parametter.locale2 - Dictionnaire du site web
 * @param {Array<object>} parametter.events - Liste des articles
 * @param {object} parametter.links - Liste des liens du site web.
 * @param {boolean} parametter.alternate - Indique si la version alternative de ce composant doit être activé.
 * @returns 
 */
export default function LastNews({articles,locale,alternate,lang,links,locale2}){

    const [lastArticle,setLastArticles] = useState(null)
    const [AlternateLastArticle,setAlternateLastArticle] = useState(null)


    useEffect(()=>{
        let Articles = articles.map(e=> {
            return {
            ID:e.ID,
            DATA: JSON.parse(e.DATA)
            }
        })
    
        Articles =
        Articles.map((e)=> {
            return {
            ID:e.ID,
            DATA:{
                date:e.DATA.date,
                author:e.DATA.author,
                articlePhoto:e.DATA.articlePhoto ,
                articleGallery: e.DATA.articleGallery,
                youtubeLink:e.DATA.youtubeLink,
                nameFr:decodeURI(atob(e.DATA.nameFr)),
                textFr:decodeURI(atob(e.DATA.textFr)),
                nameEn:decodeURI(atob(e.DATA.nameEn)),
                textEn:decodeURI(atob(e.DATA.textEn)),
                nameNl:decodeURI(atob(e.DATA.nameNl)),
                textNl:decodeURI(atob(e.DATA.textNl)),
            }
            }
        })

        setLastArticles([Articles[0],Articles[1],Articles[2]])
        setAlternateLastArticle([Articles[0],Articles[1],Articles[2],Articles[3]])
    },[])

    if(!alternate)
    
    {return(
            <div className={"lg:p-20 py-8 flex grid lg:grid-cols-4 justify-between items-center lg:gap-6 Laste-News "}>
                <div className="text-center lg:text-left space-y-4 px-8">
                    <h3 className=" text sub paragraph lora">{locale.LastNews}</h3>
                    <h2 className=" text heading-3 font-bold">{locale.InTheSpotlight}</h2>
                    <p className=" text paragraph">{locale.text}</p>
                    <Link href={links.News} className="hidden md:block">
                        <button className="button-primary-2 large-button">
                            {locale.button}
                        </button>
                    </Link>
                    
                </div>
                <div className="lg:col-span-3 overflow-x-auto lg:overflow-visible p-8">
                    <div className="grid grid-cols-3 gap-6 w-[1000px] lg:w-full">
                        {
                            lastArticle && lastArticle.map((e,i)=>
                               e ? <NewsCard isAlternate={alternate} local={locale2} mainPicture={e.DATA.articlePhoto} date={e.DATA.date} lang={lang} title={lang=="fr"?e.DATA.nameFr:(lang=="en"?e.DATA.nameEn:e.DATA.nameNl)} buttonText={locale.buttonNews} key={i} id={e.ID}/> : null
                            )
                        }
                    </div>
                </div>
                <Link href={links.News} className="md:hidden mx-auto mt-8 px-8">
                        <button className="my-4 button-primary-2 large-button">
                            {locale.button}
                        </button>
                </Link>
            </div>
    );}
    else {
        return(
            <div className={"lg:p-20 p-8 lg:gap-6 Laste-News Last-News-alternate"}>
                <div className="text-center">
                    <h3 className="py-2 text-xl">{locale.LastNews}</h3>
                    <h2 className="py-2 text-4xl">{locale.InTheSpotlight}</h2>
                    
                </div>
                <div className="overflow-x-auto lg:overflow-visible pb-4">
                    <div className="grid grid-cols-4 gap-6 w-[1400px] lg:w-full">
                    {
                            AlternateLastArticle && AlternateLastArticle.map((e,i)=>
                                e ? <NewsCard isAlternate={alternate} local={locale2} mainPicture={e.DATA.articlePhoto} date={e.DATA.date} lang={lang} title={lang=="fr"?e.DATA.nameFr:(lang=="en"?e.DATA.nameEn:e.DATA.nameNl)} buttonText={locale.buttonNews} key={i} id={e.ID}/> : null
                        )
                        }
                    </div>
                </div>
                <div className="text-center w-full">
                    <Link href={links.News} className="w-full">
                        <button className="my-4 button-primary-2 large-button md:w-auto w-full">
                            {locale.button}
                        </button>
                    </Link>
                </div>
                
            </div>
    );
    }
}